module.exports = __webpack_public_path__ + "img/d201209-1.a29640f1.jpg";